import React from 'react';
import Table from '../../components/Table';
import NoContent from '../../components/NoContent';
import TableSkeleton from '../../components/Skeletons/TableSkeleton';

const OrgListTable = ({
  orgsList,
  searchKey,
  handleToggleButtonClick,
  handleResetPasswordButtonClick,
  handleEditOrgButtonClick,
  handleDeleteOrgButtonClick,
}) => {
  return (
    <Table
      thead={
        <tr>
          <th />
          <th>Name</th>
          <th>E-mail</th>
          <th>Phone</th>
          <th>Address</th>
          <th>Space Used</th>
          <th>File Admins</th>
          <th>File Users</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      }
      tbody={
        orgsList && orgsList.loading ? (
          <TableSkeleton rows={10} columns={10} />
        ) : orgsList &&
          orgsList.orgs &&
          orgsList.orgs.status === 'success' &&
          orgsList.orgs.data &&
          orgsList.orgs.data.data &&
          orgsList.orgs.data.data.length > 0 ? (
          orgsList.orgs.data.data
            .filter(org => org.name.toLowerCase().includes(searchKey.toLowerCase()))
            .map(org => {
              const totalSpace = org.customClientDetails ? org.customClientDetails.space : '0';
              const usedSpace = org.usedSpace ? org.usedSpace?.toFixed(3) : '0';
              const totalAdmins = org.customClientDetails ? org.customClientDetails.adminUsers : '0';
              const usedAdmins = org.fileAdminCount ? org.fileAdminCount : '0';
              const totalUsers = org.customClientDetails ? org.customClientDetails.downloadUsers : '0';
              const usedUsers = org.fileUserCount ? org.fileUserCount : '0';

              return (
                <tr key={org._id}>
                  <td className='table__profile_container'>
                    <img src='/assets/profile.png' alt={org.name} className='table__profile_image' />
                  </td>
                  <td className='table__row_title'>{org.name}</td>
                  <td>{org.email}</td>
                  <td>{org.phone}</td>
                  <td>{org.address}</td>
                  <td>{usedSpace + ' / ' + totalSpace + ' GB'}</td>
                  <td>{usedAdmins + ' / ' + totalAdmins}</td>
                  <td>{usedUsers + ' / ' + totalUsers}</td>
                  <td>
                    <div className='flex'>
                      {org.active ? (
                        <p className='table__status'>
                          <span>•</span> Active
                        </p>
                      ) : (
                        <p className='table__status_deactive'>
                          <span>•</span> Deactive
                        </p>
                      )}
                      <label className='switch'>
                        <input
                          id={org._id}
                          checked={org.active}
                          onChange={() => handleToggleButtonClick(org)}
                          type='checkbox'
                          className='checkbox'
                          name='active'
                        />
                        <span className='slider round' />
                      </label>
                    </div>
                  </td>
                  <td className='table__buttons'>
                    <button className='table__button' onClick={() => handleResetPasswordButtonClick(org)}>
                      <svg className='table__button_icon'>
                        <use xlinkHref={`/assets/sprite.svg#icon-lock`} />
                      </svg>
                    </button>
                    <button className='table__button' onClick={() => handleEditOrgButtonClick(org)}>
                      <svg className='table__button_icon'>
                        <use xlinkHref={`/assets/sprite.svg#icon-edit`} />
                      </svg>
                    </button>
                    <button className='table__button_delete' onClick={() => handleDeleteOrgButtonClick(org)}>
                      <svg className='table__button_delete_icon'>
                        <use xlinkHref={`/assets/sprite.svg#icon-trash`} />
                      </svg>
                    </button>
                  </td>
                </tr>
              );
            })
        ) : (
          <tr className='noContent_table_row'>
            <td colSpan={8}>
              <NoContent title1="Sorry, we couldn't find any client data." />
            </td>
          </tr>
        )
      }
    />
  );
};

export default OrgListTable;
